import { createSlice } from "@reduxjs/toolkit";

export const selectedClientSlice = createSlice({
  name: "selected client",
  initialState: {
    selectedClient: null,
  },
  reducers: {
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    },
  },
});

export const { setSelectedClient } = selectedClientSlice.actions;

export default selectedClientSlice.reducer;
